// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offices-list{padding:45px 0}.offices-list__filter{font-size:12px;font-size:.75rem;line-height:1.5;margin:0;padding:30px 0}.offices-list__list{display:flex;list-style:none;margin:0;padding:15px 0}@media(min-width:992px){.offices-list__empty{padding:45px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
